import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { StaticQuery, graphql, Link } from 'gatsby'
import { X, ChevronLeft, ChevronRight } from 'react-feather'

const ExteriorHomeVisualizer = () => (
  <StaticQuery
    query={graphql`
      query {
        file: file(relativePath: { eq: "exterior-home-visualizer.webp" }) {
          childImageSharp {
            gatsbyImageData(width: 360)
          }
        }
      }
    `}
    render={(data) => {
      const image = getImage(data.file?.childImageSharp) // Ensure data.file exists
      if (!image) return <p>Error loading image</p> // Optional error handling

      return (
        <div
          className="mb-3 bg-white border-radius shadow-md p-4"
          style={{
            background:
              'linear-gradient(145deg, rgb(249, 250, 251) 60%, rgb(255, 255, 255) 50%)',
          }}
        >
          <h4 className="font-bold leading-6 px-1 text-black text-center text-xl mb-2 mt-4">
            Try Our 3D Home Design Visualizer!
          </h4>
          <p className="mt-3 mb-5 leading-medium px-3 text-center text-black">
            Ready to explore the possibilities for your home? Snap a photo to
            get started or spark your imagination with our sample homes.
          </p>

          <Link
            className="border-radius button-style-primary text-base font-semibold mt-4 rounded-full flex flex-col items-center justify-between col-span-1 md:col-span-2 lg:col-span-1 py-2 px-3 shadow-md hover:shadow-lg hover:bg-white hover:cursor-pointer cursor-pointer"
            to={`https://rwpro.renoworks.com/pages/project/automasker?contractor=gvdrenovation`}
            rel="nofollow"
            target="_blank"
            style={{ maxWidth: '200px', margin: 'auto', marginBottom: '18px' }}
          >
            <span className="flex items-center justify-center babtn">
              Start Designing <ChevronRight />
            </span>
          </Link>
          <GatsbyImage
            className="mb-3 border-radius text-center"
            image={image}
            alt="Exterior Home Design Visualizer"
          />
        </div>
      )
    }}
  />
)

export default ExteriorHomeVisualizer
